import { useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import PATH, { GOOGLE_REDIRECT_URI } from '../../../../constants/url';
import { getDpSnsExists, getDpSnsSignin } from '../../../../assets/js/comm';

import MSG from '../../../../constants/message';
import ToastPopup from '../../../../components/comm/ToastPopup';
import URL from '../../../../constants/url';

const GoogleRedirectPage = () => {
    const navigate = useNavigate();
    const isProcessing = useRef(false);

    const authCode = useMemo(() => {
        return new window.URL(window.location.href).searchParams.get('code');
    }, []);

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [sec, setSec] = useState(3);

    const [redirecting, setRedirecting] = useState(false);
    const [baseMsg, setBaseMsg] = useState('');

    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    const clearTimers = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        intervalRef.current = null;
        timeoutRef.current = null;
    };

    // 공통 카운트다운 시작 함수
    const startRedirect = (message, seconds = 3) => {
        clearTimers();
        setBaseMsg(message);
        setSec(seconds);
        setToast(true);
        setRedirecting(true);

        intervalRef.current = setInterval(() => {
        setSec((s) => (s > 0 ? s - 1 : 0));
        }, 1000);

        timeoutRef.current = setTimeout(() => {
        navigate(PATH.LANDING, { replace: true });
        }, seconds * 1000);
    };

    // 카운트다운 문구 갱신
    useEffect(() => {
        if (redirecting) {
        setToastMessage(`${baseMsg} ${sec}초 후 \n로그인 화면으로 이동합니다.`);
        }
    }, [redirecting, baseMsg, sec]);

    // 마운트/언마운트 타이머 정리
    useEffect(() => {
        return () => clearTimers();
    }, []);

    const oauthLogin = useCallback(async (code) => {
        if (isProcessing.current) return;

        isProcessing.current = true;

        try {
            // redirectUri : 토큰 교환 시 authorize 때와 동일한 값이어야 해서 프론트가 그대로 넘긴다
            const res = await axiosApi.post("/oauth/google", { code, redirectUri: GOOGLE_REDIRECT_URI });
            //console.log('토큰을 넘겨줘 : ', res);

            const accessToken = res.data.result.tokens.accessToken;
            const email = res.data.result.tokens.email;
            const idToken = res.data.result.tokens.idToken;
            sessionStorage.setItem('sns_token', idToken);
            sessionStorage.setItem('sns_email', email);

            getDpSnsExists('google', idToken)
            .then(async (res) => {
                //false = 가입 안되어있음 or 연동 안되어있음
                if(!res) {
                    //구글 + 애플은 idToken이 accessToken 역할을 함
                    navigate(PATH.IDENTITY, { replace: true, state: { sns: 'google', provider: 'google', accessToken: idToken , email : email } });
                } else {
                    const pushToken = sessionStorage.getItem('pushToken') || '';
                    //구글 + 애플은 idToken이 accessToken 역할을 함
                    const signRes = await getDpSnsSignin({ sns : 'google', idToken : idToken, pushToken : pushToken});

                    if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {
                        const jToken = signRes?.accessToken;
                        const refreshToken = signRes?.refreshToken;
                        const requestLoginUrl = "/signup/loginUser"; //"/signup/user";

                        const requestOptions = {
                            headers: {
                                Authorization: `Bearer ${jToken}`,
                            }
                            , params: {
                                refreshToken: refreshToken
                            }
                        }

                        await axiosApi.post(requestLoginUrl, {}, requestOptions)
                            .then((res) => {
                                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                    const iitpUser = res.data.result.iitpUser;

                                    sessionStorage.removeItem("targetHsptl");//병원케어 메뉴 초기화
                                    sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));
                                    localStorage.setItem('jToken', jToken);
                                    localStorage.setItem("IITP_CRTFC_TKN", refreshToken);

                                    // 일반 로그인(LoginMain)과 동일한 기준으로 분기한다.
                                    if (iitpUser.usrHsptlMap?.length > 0) {
                                        if (iitpUser.usrHsptlMap[0].paCd) {
                                            navigate(PATH.HOME_MAIN);
                                        } else {
                                            // 신체활동계수 미등록이면 등록을 유도한다.
                                            navigate(PATH.ACTIVITY_LEVEL_SELECT);
                                        }
                                    } else {
                                        // 병원 연결이 안 된 계정. IITP 는 관리자 문의로 안내한다.
                                        startRedirect('병원연결이 되지 않았습니다.\n관리자에 문의해 주십시오!');
                                    }

                                } else {
                                    startRedirect(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
                                }
                            })
                            .catch((err) => {
                                console.log(" ================> RCV_ERROR_SERVER ", err);
                            })

                    } else {
                        alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                    }
                }
            })
            .catch( (err) => {
                alert(err)
                if(err.response.status === Number(CODE.RCV_BAD_UNAUTH)) {
                }
            });

        } catch (err) {
            console.error("api/oauth/google 호출 중 오류 : ", err);
        } finally {
            isProcessing.current = false;
        }
    }, []);

    useEffect(() => {
        if (authCode) {
            oauthLogin(authCode);
        }
    }, [authCode, oauthLogin]);

    return (
        <>
        <div>로그인 중입니다...</div>
        {toast && (
            <ToastPopup
            setToast={setToast}
            position={"center"}
            message={toastMessage}
            />
        )}
        </>
    );
};

export default GoogleRedirectPage;
